/**
 * W66.W6 — Right pane: renders the 7-section Plan Detail for a selected account.
 * Sections: (a) Header, (b) ICP Fit, (c) Intel Table, (d) Relationship + Entry Path,
 *           (e) Persona Triad, (f) Checkpoint Snapshot, (g) Cadence Bundle.
 */

import React from "react";
import HeaderStrip from "./HeaderStrip";
import IcpFitBlock from "./IcpFitBlock";
import IntelTable from "./IntelTable";
import RelationshipBlock from "./RelationshipBlock";
import PersonaTriad from "./PersonaTriad";
import CpSnapshot from "./CpSnapshot";
import CadenceBundle from "./CadenceBundle";

interface PlanDetailViewProps {
  accountName: string;
  planData: Record<string, any>;
  loading?: boolean;
  error?: string | null;
}

export default function PlanDetailView({
  accountName,
  planData,
  loading,
  error,
}: PlanDetailViewProps) {
  if (loading) {
    return (
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#9CA3AF",
          fontSize: 14,
        }}
      >
        Loading plan...
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#DC2626",
          fontSize: 14,
        }}
      >
        {error}
      </div>
    );
  }

  if (!accountName || Object.keys(planData).length === 0) {
    return (
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 8,
          color: "#9CA3AF",
        }}
      >
        <div style={{ fontSize: 32 }}>&#128196;</div>
        <div style={{ fontSize: 14 }}>Select an account from the left to view the plan.</div>
      </div>
    );
  }

  return (
    <div
      style={{
        flex: 1,
        overflowY: "auto",
        padding: 32,
        background: "#F9FAFB",
      }}
    >
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <HeaderStrip accountName={accountName} planData={planData} />
        <IcpFitBlock planData={planData} />
        <IntelTable planData={planData} />
        <RelationshipBlock planData={planData} />
        <PersonaTriad planData={planData} />
        <CpSnapshot planData={planData} />
        <CadenceBundle planData={planData} />
      </div>
    </div>
  );
}
